import React from "react";
import { useAppearingText } from "views/animation";

export const Description = ({ fullText, ...props }) => {
  const text = useAppearingText(fullText);

  return <p {...props}>{text}</p>;
};
